import Vue from 'vue'
import Router from 'vue-router'

const TestDrive = () => import('@/pages/test_drive/TestDrive.vue');
const TestDriveDealer = () => import('@/pages/test_drive/TestDriveDealer.vue');
const TestDriveTime = () => import('@/pages/test_drive/TestDriveTime.vue');
const TestDriveContacts = () => import('@/pages/test_drive/TestDriveContacts.vue');
const TestDriveConfirmation = () => import('@/pages/test_drive/TestDriveConfirmation.vue');
const TestDriveFinish = () => import('@/pages/test_drive/TestDriveFinish.vue');

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'TestDrive',
            component: TestDrive,
            redirect: '/dealer',
            children: [
                {
                    path: 'dealer',
                    name: 'TestDriveDealer',
                    component: TestDriveDealer
                },
                {
                    path: 'time',
                    name: 'TestDriveTime',
                    component: TestDriveTime
                },
                {
                    path: 'contacts',
                    name: 'TestDriveContacts',
                    component: TestDriveContacts
                },
                {
                    path: 'confirmation',
                    name: 'TestDriveConfirmation',
                    component: TestDriveConfirmation
                },
                {
                    path: 'finish',
                    name: 'TestDriveFinish',
                    component: TestDriveFinish
                }
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/test-drive.js